import { QueryParam } from '../Constants';

export const resolveAppStyles = () => {
  const brand = (new URLSearchParams(location.search).get(QueryParam.Brand) || 'TELIA').toLowerCase();
  fetch('/brandfree-prepaid/static/manifest.json')
    .then((res) => res.json())
    .then((manifest) => {
      if (document.querySelector(`link[href^="${manifest[`${brand}-styles.css`]}"]`)) {
        return;
      }
      const cssElement = document.createElement('link');
      cssElement.rel = 'stylesheet';
      cssElement.type = 'text/css';
      cssElement.href = `${manifest[`${brand}-styles.css`]}`;
      document.head.appendChild(cssElement);
    })
    .catch((err) => console.error(err));
};
